
const JoinSecretarySection = ({hideElem}) => {
   return (
    <section className="ftco-section ftco-no-pt ftco-no-pb"> 
      <div className="container">
        {!hideElem && (
          <div className="row justify-content-center mt-3 pb-4">
            <div className="col-md-12  heading-section ftco-animate text px-4">
              <h2 className="mb-4 text-success text-center">
                <span className="text-warning">Management </span> Team
              </h2>
            </div>
          </div>
        )}

        <div className="row mt-3">
        <div className=" col-md-12 order-md-first">
            <div className="text px-4">
              <h2 className="mb-4 text-primary">Joint Secretary’s Message</h2>
              <p> Welcome to Kaamadhenu College of Education.</p>
              <p>
Teacher education carries the responsibility of shaping educators who can respond
thoughtfully to the evolving needs of learners and society. Kaamadhenu College of Education
is committed to this responsibility by providing a structured academic environment that
supports professional preparation and reflective learning. </p>
<p>
As Joint Secretary, I believe that quality teacher education is built on strong academic
practices, disciplined learning, and continuous engagement with pedagogical processes. The
institution focuses on creating opportunities for student teachers to develop subject
understanding, teaching competence, and professional confidence through academic activities
 and guided practice. </p>
 <p>
The college encourages student teachers to approach learning with commitment, self
discipline, and a sense of responsibility towards the teaching profession. By making effective
use of the academic resources and guidance provided, students are expected to grow into
teachers who uphold professional standards and contribute positively to educational
institutions. </p>

<p>I wish all student teachers a productive academic journey and trust that their time at
Kaamadhenu College of Education will prepare them for meaningful service in the field of
education. </p>
             
              <h5 className='font-weight-bold text-left'>With best wishes,<br/>Dr. P. Malar Selvi. <br/><span className="qualification">M.A.,M.Ed.,M.A.,M.Phil.,Ph.D.</span>
              <br/>Joint Secretary</h5>
             </div>
          </div>
        </div>  
      </div>  
      <hr className="custom-hr"/>
    </section>
  );
};

export default JoinSecretarySection;
